export enum ScaleQueryType {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
}

export enum ScaleDashboardSubTab {
    CUSTOMER_ORDER = 'CUSTOMER_ORDER',
    PICKUP_ORDER = 'PICKUP_ORDER',
    LAST_MILE_ORDER = 'LAST_MILE_ORDER',
    PICKUP_TREND = 'PICKUP_TREND',
}

export enum ScaleDashboardMetric {
    ORDER = 'ORDER',
    PICKUP = 'PICKUP',
}

/** 与后端 OrderFlowType / scale_dashboard_hourly_summary.order_flow_type 一致 */
export const OrderFlowType = {
    NORMAL: 1,
    SORTING_ONLY: 2,
} as const;

export interface ScaleDashboardQueryInput {
    queryType: ScaleQueryType;
    startDate: string; // YYYY-MM-DD
    endDate: string; // YYYY-MM-DD
    hubId: number;
    customerType?: number | null;
    customerName?: string | null;
    /** 1 普通订单 2 仅分拣订单，默认 1 */
    orderFlowType?: number | null;
    subTab?: string | null;
    startHour?: number | null;
    endHour?: number | null;
}

export interface ScaleDashboardHistoricalMaxQueryInput {
    queryType: ScaleQueryType;
    startDate: string; // YYYY-MM-DD
    endDate?: string | null; // YYYY-MM-DD, optional
    hubId: number;
    customerType?: number | null;
    customerName?: string | null;
    metric: ScaleDashboardMetric;
    orderFlowType?: number | null;
    subTab?: string | null;
}

export interface ScaleDashboardHistoricalMaxResult {
    queryType: ScaleQueryType;
    metric: ScaleDashboardMetric;
    maxValue: number;
    maxPeriods: string[];
    startDate: string;
    endDate: string;
}

/** 字段名与 scale_dashboard_hourly_summary 表列一致 */
export interface ScaleDashboardItem {
    timePeriod: string;
    pickupHubId?: number | null;
    destHubId?: number | null;
    destWarehouseId?: number | null;
    pickupHubSortingCode?: string | null;
    destHubSortingCode?: string | null;
    destWarehouseSortingCode?: string | null;
    customerType?: number | null;
    customerName?: string | null;
    orderCount: number;
    pickupCount: number;
}

export interface ScaleDashboardResult {
    items: ScaleDashboardItem[];
    dataUpdatedAt?: string | null;
}

export interface QueryScaleDashboardResponse {
    queryScaleDashboard: ScaleDashboardResult;
}

export interface QueryScaleDashboardHistoricalMaxResponse {
    queryScaleDashboardHistoricalMax: ScaleDashboardHistoricalMaxResult;
}
